import { Box } from '@mui/material'
import { css } from '@emotion/react'
import styled from '@emotion/styled'

import type { SeparatorProps } from './types'

export const Separator = styled(Box)<SeparatorProps>`
  ${({ theme }) => css`
    height: 1px;
    margin-top: 24px;
    background: ${theme.colors.blue.line};
  `}
`
